// eslint-disable-next-line import/no-anonymous-default-export
import {EDIT_PAYLOAD_FAMILYGROUP,EMPTY_PAYLOAD_FAMILYGROUP} from '../Types/types'


// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = {data: null}, action: any) {
  switch (action.type) {
    case EDIT_PAYLOAD_FAMILYGROUP:
      return {
        ...state,
        data: action.payload,
      }
      case EMPTY_PAYLOAD_FAMILYGROUP:
        return{
          data: null
        }
    default:
      return state
  }
}